import "bootstrap/dist/css/bootstrap.min.css";

import { ListGroup, Table } from "react-bootstrap";

function Intro() {
  return (
    <>
      <div style={{ position: "relative" }}>
        <img
          alt="낮고 긴 이미지"
          style={{ width: "100%" }}
          src="/topbanner.jpg"
        />
      </div>
      <ListGroup as="ol" numbered>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">이용시간</div>
            월-금, 14:00~23:00
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">연락처</div>
            센터장 이정옥, 010-3892-8850
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">이용금액</div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>기간</th>
                  <th>성인</th>
                  <th>학생</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1개월</td>
                  <td>80,000원</td>
                  <td>70,000원</td>
                </tr>
                <tr>
                  <td>3개월</td>
                  <td>220,000원</td>
                  <td>190,000원</td>
                </tr>
                <tr>
                  <td>6개월</td>
                  <td>430,000원</td>
                  <td>380,000원</td>
                </tr>
                <tr>
                  <td>12개월</td>
                  <td>800,000원</td>
                  <td>700,000원</td>
                </tr>
                <tr>
                  <td>1일권</td>
                  <td colSpan={2}>10,000원</td>
                </tr>
                <tr>
                  <td>10회권</td>
                  <td colSpan={2}>90,000원</td>
                </tr>
                <tr>
                  <td>단체 강습(5인 이상)</td>
                  <td colSpan={2}>1인당 12,000원</td>
                </tr>
              </tbody>
            </Table>
            <p>*1일권 이용시 강습료+암벽화 대여료 5,000원 별도</p>
            <p>*10회권 이용시 강습료+암벽화 대여료 50,000원 별도</p>
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">시설 소개</div>
            <p>남, 여 탈의실 및 샤워장(온수, 라커룸 완비)</p>
            <p>트레이닝 보드 다량 구비</p>
            <p>단계별로 경사각이 심화되는 지구력 벽으로 구성</p>
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">주소</div>
            대구 수성구 달구벌대로467길 13, 3층, 대구파워클라이밍센터
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">오시는 길</div>
            <div>
              <img style={{ width: "80%" }} alt="이미지" src="/loca.png" />
            </div>
            수성네거리 투썸플레이스 뒷 건물 3층. 주차는 건물 앞 및 골목 주차
          </div>
        </ListGroup.Item>
        <ListGroup.Item
          as="li"
          className="d-flex justify-content-between align-items-start">
          <div className="ms-2 me-auto">
            <div className="fw-bold">커뮤니티</div>
            <div>
              <button
                className="btn btn-primary mt-3"
                href="https://cafe.daum.net/powerclimbingzone">
                다음카페
              </button>
            </div>
            <div>
              <button
                className="btn btn-primary mt-3 mb-3"
                href="https://blog.naver.com/powerclimb">
                센터장블로그
              </button>
            </div>
          </div>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
}

export default Intro;
